import React from 'react';
import MagicForm from '../../Form/MagicForm';
import { ItemScheme } from '../../Form/MagicFormItem';
import { FormValues } from '../../../Modules/MagicForm/Interfaces/FormValues';
import { MagicField } from '../../../Enums/MagicField.enum';
import usePatientConsent from '../../PatientProfile/Hooks/usePatientConsent';
import { useMedicalReportDefaultData } from '../../../Modules/MedicalReport/Hooks/useMedicalReportDefaultData';

interface Props {
	onSubmit: (values: FormValues) => void;
	defaultData?: any;
	disableSubmit?: boolean;
	patientId: string;
	isMeddiCase: boolean;
}

const MedicalReportDetailHungaryForm: React.FC<Props> = ({
	onSubmit,
	defaultData,
	disableSubmit,
	patientId,
	isMeddiCase,
}) => {
	const { isConsentProvided } = usePatientConsent(patientId);
	const { formDefaultData } = useMedicalReportDefaultData({
		isMeddiCase,
		defaultData,
		isConsentProvided,
	});

	// @ts-ignore
	const handleSubmit = async values => {
		values.diagnosis = values?.diagnosis?.label;
		onSubmit(values);
	};

	const formScheme: ItemScheme[] = [
		{
			type: MagicField.TEXT_FIELD,
			key: 'title',
			title: 'component.medicalReportDetailHungaryForm.title',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.TEXT_FIELD,
			key: 'text',
			title: 'component.medicalReportDetailHungaryForm.text',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.TEXT_FIELD,
			key: 'status',
			title: 'component.medicalReportDetailHungaryForm.status',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.DIAGNOSIS_CZECH,
			key: 'diagnosis',
			title: 'component.medicalReportDetailHungaryForm.diagnosis',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.TEXT_FIELD,
			key: 'prescription',
			title: 'component.medicalReportDetailHungaryForm.prescription',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.TEXT_FIELD,
			key: 'suggestion',
			title: 'component.medicalReportDetailHungaryForm.suggestion',
			settings: {
				required: true,
			},
		},
	];

	if (isConsentProvided) {
		formScheme.push(
			{
				type: MagicField.WHITESPACE,
			},
			{
				type: MagicField.CHECKBOX,
				key: 'addToPatientECard',
				title: 'base.addToPatientECard',
				settings: {
					disabled: isMeddiCase,
				},
			},
		);
	} else {
		formScheme.push(
			{
				type: MagicField.PATIENT_CONSENT_REQUEST,
				settings: {
					patientId,
				},
			},
			{
				type: MagicField.WHITESPACE,
			},
		);
	}

	return (
		<MagicForm
			formScheme={formScheme}
			onSubmit={handleSubmit}
			defaultValues={formDefaultData}
			disableSubmit={disableSubmit}
		/>
	);
};

export default MedicalReportDetailHungaryForm;
